export interface UpdateOrderMemoRequest {
  // 発注ID
  id: number
  workMemo: string
  displayMemo: string
  localMemo: string
  revision: number
}

export const defaultUpdateOrderMemoRequest = (): UpdateOrderMemoRequest => ({
  id: 0,
  workMemo: '',
  displayMemo: '',
  localMemo: '',
  revision: 0
})

export function UpdateOrderMemoRequestToJSON(
  value: UpdateOrderMemoRequest
): any {
  return {
    id: value.id,
    work_memo: value.workMemo,
    display_memo: value.displayMemo,
    local_memo: value.localMemo,
    revision: value.revision
  }
}
